import {Profiler, useEffect} from 'react';
import {IntlProvider} from 'react-intl';
import {Provider as UniqueIdGeneratorProvider} from '@inline-svg-unique-id/react';
import {
    Router,
} from 'react-router-dom';
import browserHistory from '@/browserHistory';

import {messages, locale} from '@/locales';
import {reportCdnFail} from '@/buried/common';
import {getDevice, isHi} from '@/utils/browserUtils';
import WeirwoodErrorBoundary from '../WeirwoodErrorBoundary';
import {ENVIRONMENT_LEVEL} from '@/Constant';
import TocEntry from '@/tocPages/TocEntry';
import {set as localStorageSet} from '@/utils/storageUtils';
// 引入个人主页的深浅背景颜色主题
import '@/domains/user/common/theme.scss';
import {perfLogger, PROFILER_KEY} from '@/buried/performance';

const device = getDevice();

// cdn不可用时埋点
if (document.cookie.includes('CDNUnavailable=1')) {
    setTimeout(() => {
        reportCdnFail();
    }, 1000);
}

function App() {
    // 灰度环境提示
    useEffect(() => {
        localStorageSet('process-env', process.env);
    }, []);

    // toc屏蔽灰度提示
    // useEffect(() => {

    //     if (process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT_LEVEL.gray && device.platform !== 'mobile') {
    //         import('../domains/user/components/grayEnvToast').then(moudle => {
    //             moudle.grayToast();
    //         });
    //     }
    // }, []);

    return (
        <WeirwoodErrorBoundary>
            <IntlProvider
                locale={locale}
                messages={messages.zh}
            >
                <Router history={browserHistory}>
                    <UniqueIdGeneratorProvider idPrefix="rlkb">
                        <Profiler id={PROFILER_KEY.entry} onRender={perfLogger.compRender.onRender}>
                            <TocEntry />
                        </Profiler>
                    </UniqueIdGeneratorProvider>
                </Router>
            </IntlProvider>
        </WeirwoodErrorBoundary>
    );
}

export default App;
